import { cn } from "@/lib/utils";
import React from "react";

type Variant = "default" | "primary" | "secondary" | "subtle";
type Size = "sm" | "md" | "lg" | "xl" | "xxl";

interface SectionHeaderProps {
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  className?: string;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export function SectionHeader({
  children,
  variant = "default",
  size = "lg",
  className,
  as: Component = "h2",
}: SectionHeaderProps): JSX.Element {
  const variantStyles: Record<Variant, string> = {
    default: "text-foreground",
    primary: "font-semibold text-foreground dark:text-white",
    secondary: "font-base text-orange-900 dark:text-white",
    subtle: "font-light",
  };

  const sizeStyles: Record<Size, string> = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
    xl: "text-4xl",
    xxl: "text-6xl",
  };

  return (
    <Component
      className={cn(
        "font-heading",
        variantStyles[variant],
        sizeStyles[size],
        className
      )}
    >
      {children}
    </Component>
  );
} 